import { InfoNote } from '../../components/InfoNote';
import { DesktopOnly, MobileOnly } from '../../components/Layout';
import { PageSection } from '../../components/Section';
import { SideImage } from '../../components/SideImage';
import { SkeletonCard, SkeletonRow } from '../../components/SkeletonCard';
import { ContentPanel } from '../../composites/ContentPanel';
import { SplitLayout } from '../../composites/SplitLayout';
import { JourneyBarGroup } from './SpaTreatmentFacilityDetailTemplate.styles';
import { layout } from '../../theme/tokens';
import type { SpaTreatmentFacilityTemplateProps } from './SpaTreatmentFacilityDetailTemplate.types';

export function SpaTreatmentFacilityDetailTemplate({
  imageUrl,
  imageAlt,
  title,
  price,
  discount,
  priceLabel,
  promotionName,
  categoryLabel,
  description,
  termsContent,
  termsLabel,
  onReserve,
  reserveLabel,
  onBack,
  viewAllLabel,
  telephoneOnly,
  unavailable,
  recommendations,
  booking,
  isLoading,
  journeyBar,
  guestLimitNotice,
}: SpaTreatmentFacilityTemplateProps) {
  const showRecommendations = isLoading || !!recommendations;
  const bookable = !telephoneOnly && !unavailable;
  const shownBooking = bookable ? booking : undefined;
  const desktopJourneyBar = journeyBar ? <DesktopOnly>{journeyBar}</DesktopOnly> : null;

  return (
    <>
      <SplitLayout
        left={
          <SideImage
            src={imageUrl}
            alt={imageAlt}
            sticky
            mobileAspectRatio={layout.detailImageMobileAspectRatio}
            onBack={onBack}
            backLabel={viewAllLabel}
            overlayContent={journeyBar ? <MobileOnly>{journeyBar}</MobileOnly> : undefined}
          />
        }
        right={
          <>
            {guestLimitNotice ? (
              <JourneyBarGroup>
                {desktopJourneyBar}
                <InfoNote text={guestLimitNotice} />
              </JourneyBarGroup>
            ) : (
              desktopJourneyBar
            )}
            <ContentPanel
              title={title}
              price={price}
              discount={discount}
              priceLabel={priceLabel}
              promotionName={promotionName}
              categoryLabel={categoryLabel}
              description={description}
              termsContent={termsContent}
              termsLabel={termsLabel}
              onReserve={bookable && !shownBooking ? onReserve : undefined}
              reserveLabel={reserveLabel}
              reserveUnderPrice
              isLoading={isLoading}
              telephoneOnly={telephoneOnly}
              unavailable={
                !telephoneOnly && unavailable
                  ? {
                      ...unavailable,
                      onCtaClick: unavailable.onCtaClick ?? onBack,
                      onSecondaryCtaClick: unavailable.onSecondaryCtaClick ?? onBack,
                    }
                  : undefined
              }
            >
              {shownBooking}
            </ContentPanel>
          </>
        }
      />

      {showRecommendations && (
        <PageSection $fullWidth data-bleed-right="true">
          {isLoading ? (
            <SkeletonRow>
              {Array.from({ length: 4 }).map((_, i) => (
                <SkeletonCard key={i} variant="grid" />
              ))}
            </SkeletonRow>
          ) : (
            recommendations
          )}
        </PageSection>
      )}
    </>
  );
}
